import { action, Module, mutation, VuexModule } from 'vuex-class-component';

@Module()
export class EnvSettingsModule extends VuexModule {
  private newFinishesEnabled = false;

  @action({ mode: 'mutate' })
  public async setNewFinishesEnabled(value: boolean) {
    this._setNewFinishesEnabled(value);
  }

  @mutation private _setNewFinishesEnabled(value: boolean) {
    this.newFinishesEnabled = value;
  }

  get getNewFinishesEnabled(): boolean {
    return this.newFinishesEnabled;
  }
}
